var exports = {
  "l": "xcc377c0b--556496--phone",
};

module.exports = exports;
